<form class="column gap" [formGroup]="userForm">
  <mat-toolbar class="center modal__toolbar">
    <div class="row gap">
      <h5 class="top-bar-view-title full-width">{{ 'InviteUserComponent.title' | translate }}</h5>
      <span class="fill-remaining-space"></span>
    </div>
    <span class="fill-remaining-space"></span>
  </mat-toolbar>
  <div class="column gap-lg modal__inputs">
    <app-chip-input
      [label]="'InviteUserComponent.email'"
      [placeholder]="'InviteUserComponent.placeholder'"
      [validateFn]="emailValidator"
      [errorMessage]="'InviteUserComponent.emailError'"
      [hintMessage]="'InviteUserComponent.hint'"
    ></app-chip-input>
    <mat-form-field floatLabel="always">
      <mat-label> Roles </mat-label>
      <mat-select [disabled]="true" formControlName="roles" multiple>
        <mat-option *ngFor="let role of roles" [value]="role">{{ displayRoles[role] }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="row horizontal-end">
      <button class="modal__button" mat-raised-button color="primary" [disabled]="userForm.invalid" (click)="createUserAndSendNotification()">
        {{ 'InviteUserComponent.invite' | translate }}
      </button>
    </div>
  </div>
</form>
